// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-progress[data-v-15b4c7f6]{position:fixed;top:0;left:0;right:0;height:3px;width:0;opacity:1;transition:width .1s,opacity .4s;z-index:999999}.nuxt-progress.nuxt-progress-notransition[data-v-15b4c7f6]{transition:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
